import keyMirror from 'keymirror';

export default keyMirror({
  RECEIVE_INVOICE: null,
  RECEIVE_INVOICE_ERROR: null,
  EMAIL_INVOICE: null,
  EMAIL_INVOICE_ERROR: null
});
